export const ProcessingListData = [
    {
    disputeId: "DSP-3001",
    id: 1,
    referenceNo: "REF-910201",
    customerName: "Anil Rai",
    accountNumber: "1010101010",
    branchName: "New Baneshwor",
    disputeType: "ATM Withdrawal Issue",
    transactionDate: "2025-10-01",
    initiatedDate: "2025-10-02",
    processingStartDate: "2025-10-03",
    amount: 15000,
    status: "Processing",
    remarks: "Pending bank verification",
    assignedTo: "officer01",
  },
  {
    disputeId: "DSP-3002",
    id: 2,
    referenceNo: "REF-910202",
    customerName: "Sushma Lama",
    accountNumber: "2020202020",
    branchName: "Kalimati",
    disputeType: "POS Transaction Failure",
    transactionDate: "2025-10-04",
    initiatedDate: "2025-10-05",
    processingStartDate: "2025-10-06",
    amount: 8000,
    status: "Processing",
    remarks: "Waiting for merchant confirmation",
    assignedTo: "officer02",
  },
  {
    disputeId: "DSP-3003",
    id: 3,
    referenceNo: "REF-910203",
    customerName: "Ramesh Thapa",
    accountNumber: "3030303030",
    branchName: "Tripureshwor",
    disputeType: "Fund Transfer Delay",
    transactionDate: "2025-10-02",
    initiatedDate: "2025-10-03",
    processingStartDate: "2025-10-04",
    amount: 22000,
    status: "Processing",
    remarks: "Investigating inter-bank delay",
    assignedTo: "officer03",
  },
  {
    disputeId: "DSP-3004",
    id: 4,
    referenceNo: "REF-910204",
    customerName: "Nisha Shrestha",
    accountNumber: "4040404040",
    branchName: "Jawalakhel",
    disputeType: "UPI Transaction Issue",
    transactionDate: "2025-10-05",
    initiatedDate: "2025-10-06",
    processingStartDate: "2025-10-07",
    amount: 4000,
    status: "Processing",
    remarks: "Checking UPI gateway logs",
    assignedTo: "officer01",
  },
  {
    disputeId: "DSP-3005",
    id: 5,
    referenceNo: "REF-910205",
    customerName: "Bibek Karki",
    accountNumber: "5050505050",
    branchName: "Thamel",
    disputeType: "Cheque Cleared Incorrectly",
    transactionDate: "2025-10-01",
    initiatedDate: "2025-10-02",
    processingStartDate: "2025-10-03",
    amount: 50000,
    status: "Processing",
    remarks: "Pending reconciliation",
    assignedTo: "officer02",
  },
]